import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import Summary from './summary';
import Management from './management';

export const accessoriesRequestsRoutes = [
  {'component': <Management />, 'path': paths.AccessoriesRequestManagement},
  {'component': <Summary />, 'path': paths.AccessoriesRequestSummary},
];
